const messages = {
    phone2FA: '2FA Teléfono',
    phoneNotification: 'Notificación Teléfono',
    changePassword: 'Cambia la Contraseña',
    currentPassword: 'Contraseña Actual',
    newPassword: 'Nueva Contraseña',
    confirmPassword: 'Confirmar Contraseña',
    submit: 'Enviar',
    myProfile: 'Mi Perfil',
    passwordChangeSuccessfully: 'La contraseña fue cambiada exitosamente',
    Password: 'Contraseña',
    forgotPassword: 'Has olvidado tu contraseña',
    checkYourEmail: 'Por favor revise su correo electrónico.',
    enterEmailAssociatedYourAccount:
        'Por favor ingrese el correo electrónico asociado con su cuenta.',
    send: 'Enviar',
    enterYourNewPassword: 'Por favor ingrese su nueva contraseña.',
    resetPassword: 'Restablecer Contraseña',
    verifyYourIdentity: 'Verifica Tú Identidad',
    receiveVerificationCode: 'Recibir el código de verificación por',
    enterCodeSentToYour: 'Por favor ingrese el código enviado a su',
    rememberDevice30Days: 'Recordar este dispositivo por 30 dias',
    verify: 'Verificar',
    resend: 'Reenviar',
    editPermissions: 'Permisos editados satisfactoriamente',
    workingSince: 'Empleado de la Empresa Desde',
    confirmUnlockAccount: 'Confirmar el desbloqueo de la cuenta de usuario',
    confirmLoginAccount: 'Confirmar ingreso con la cuenta de usuario {field}',
    noticeUnlock:
        'Ésta acción permitita al usuario acceder al sistema, algunos datos podrían perderse.',
    noticeImpersonateLogin:
        'Ésta acción permitiría al usuario acceder al sistema, algunos datos podrían perderse.',
    userAccountUnlokedSuccessfully: 'Cuenta de usuario desbloqueda satisfactoriamente',
    login: 'Login',
    greeting: 'Hola',
    updatePasswordDescription:
        'Requerimos que actualice su contraseña personal, por favor, actualícela ahora.',
    resetPasswordRequest: 'Restablecer Contraseña',
    confirmRequestUpdatePassword: 'Confirmar la solicitud de cambio de contraseña.',
    requestUpdatePasswordSuccessfully:
        'La solicitud de cambio de contraseña fue creada satisfactoriamente.',
    noticeRequestUpdatePassword:
        'Esta acción solicitará al usuario al iniciar sesión que cambie su contraseña.',
    requestPasswordUpdate: 'Cambio de contraseña requerido',
    requestPasswordUpdateDescription:
        'El usuario debe cambiar su contraseña en el próximo inicio de sesión.',
    requireMfaReregister: 'Requerir volver a registrar la autenticacion multifactor',
    myNotifications: 'Mis notificaciones',
    sent: 'Enviado',
    // Report Access keys
    failedToLoadData: 'Error al cargar los datos',
    complaintsReport: 'Reporte de Quejas',
    completedMassageReport: 'Reporte de Masajes Completados',
    cosmetologyProcedureReport: 'Reporte de Procedimientos de Cosmetología',
    cosmetologySalesReport: 'Reporte de Ventas de Cosmetología',
    expensesByExternalProviderReport: 'Reporte de Gastos por Proveedor Externo',
    generalCosmetologyReport: 'Reporte General de Cosmetología',
    generalSurgeryReport: 'Reporte General de Cirugía',
    newLeadsReport: 'Reporte de Nuevos Prospectos',
    paidInPayrollsByEmployeesReport: 'Reporte de Pagos en Nóminas por Empleados',
    paidInPayrollsByStructureReport: 'Reporte de Pagos en Nóminas por Estructura',
    productsSalesReport: 'Reporte de Ventas de Productos',
    providerChecksReport: 'Reporte de Cheques de Proveedores',
    publicityCustomerSourcesReport: 'Reporte de Fuentes de Clientes de Publicidad',
    salesBySellersReport: 'Reporte de Ventas por Vendedores',
    surgeriesAndProceduresReport: 'Reporte de Cirugías y Procedimientos',
    surgerySalesReport: 'Reporte de Ventas de Cirugía',
    totalSalesReport: 'Reporte Total de Ventas',
    workedHoursInPayrollsReport: 'Reporte de Horas Trabajadas en Nóminas',
    reportAccessSavedSuccessfully: 'Acceso a reportes guardado exitosamente',
    failedToSaveReportAccess: 'Error al guardar el acceso a reportes',
    backToUsers: 'Volver a Users',
    reports: 'Reportes',
    selectReport: 'Seleccionar Reporte',
    selectAReport: 'Seleccionar un Reporte',
    bulkActions: 'Acciones Masivas',
    selectAll: 'Seleccionar Todo',
    deselectAll: 'Deseleccionar Todo',
    officeStructure: 'Estructura de Oficinas',
    searchOffices: 'Buscar oficinas...',
    selectAReportToViewOffices: 'Seleccionar un reporte para ver oficinas',
    saving: 'Guardando...',
    manageReportAccessForUser: 'Gestionar Acceso a Reportes para: {userName}',
    offices: 'oficinas',
    reportAccess: 'Report Access',
    unsavedChanges: 'Tiene cambios sin guardar. Esta seguro que quiere salir?',
    // IT User Compliance Report keys
    userComplianceReport: 'Reporte de Cumplimiento de Usuarios de TI',
    exportCsv: 'Exportar CSV',
    exportingCsv: 'Exportando...',
    errorExportingReport: 'Error al exportar el reporte',
    contactNumber: 'Número de Contacto',
    totpPending: 'TOTP Pendiente',
    totpStatus: 'Estado TOTP',
    totpEnabled: 'TOTP Habilitado',
    totpNotRequired: 'No Requerido',
    office: 'Oficina',
    occupation: 'Ocupación',
    latestClockIn: 'Última Marcación',
    daysSinceClockIn: 'Días Desde la Marcación',
    clockInStale: 'Marcación Más Antigua Que (días)',
    clockInStale15: 'Más de 15 días',
    clockInStale30: 'Más de 30 días',
    clockInStale60: 'Más de 60 días',
    clockInStale90: 'Más de 90 días',
    excludeColombia: 'Excluir Colombia',
    excludeMassagist: 'Excluir Masajista',
    nameOrEmail: 'Nombre o Correo',
    notAvailable: 'N/D',
    pending: 'Pendiente',
    upToDate: 'Al día',
};

export default messages;
